import { defineStore } from 'pinia'
import { Message } from '../shared/models'

interface State {
  notify: Message
  isChargingBatteries: boolean
  suppressToasts: boolean
  sessionExpiryModal: {
    visible: boolean
    summary: string
    detail: string
  }
}

const useNotifications = defineStore({
  id: 'notificationStore',
  state: (): State => ({
    notify: {
      severity: 'success',
      summary: '',
      detail: '',
    },
    isChargingBatteries: false,
    suppressToasts: false,
    sessionExpiryModal: {
      visible: false,
      summary: 'Las sesión ha expirado',
      detail: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
    },
  }),
  actions: {
    addErrorNotification(notification: Message) {
      this.notify = {
        ...notification,
      }
    },
    addSuccesNotification(notificacion: Message) {
      this.notify = {
        ...notificacion,
      }
    },
    addInfoNotification(notificacion: Message) {
      this.notify = {
        ...notificacion,
      }
    },
    setLoadingState() {
      this.isChargingBatteries = true
    },
    dismissLoadingState() {
      this.isChargingBatteries = false
    },
    setToastSuppressed(value: boolean) {
      this.suppressToasts = value
    },
    clearNotification() {
      this.notify = {
        severity: undefined,
        summary: '',
        detail: '',
      }
    },
    showSessionExpiryModal(summary?: string, detail?: string) {
      this.sessionExpiryModal = {
        visible: true,
        summary: summary || 'Session expired',
        detail: detail || 'Your session expired. Please sign in again.',
      }
    },
    hideSessionExpiryModal() {
      this.sessionExpiryModal.visible = false
    },
  },
})

export default useNotifications
